import type { ReactNode } from 'react'
import { cn } from '../../lib/cn'

type GlassCardProps = {
  className?: string
  children: ReactNode
}

export function GlassCard({ className, children }: GlassCardProps) {
  return (
    <div
      className={cn(
        'glass rounded-2xl p-5 shadow-glow relative overflow-hidden',
        'before:absolute before:inset-0 before:bg-[radial-gradient(600px_circle_at_20%_0%,rgba(0,102,255,0.18),transparent_45%)] before:opacity-70 before:content-[""]',
        className,
      )}
    >
      <div className="relative">{children}</div>
    </div>
  )
}


